import Vue from 'vue'

import * as ArcGIS from '../../helpers/ArcGIS'

const state = {
  isSharingMap: false,

  host: false,

  usersShareMap: [],

  requestShareMap: null,

  mapExtent: null,

  // DIBUJOS
  graphics: [],

  // LAYERS
  visibility: null,

  opacity: null,

  // SIMULATION
  simulation: null,

  simulationTime: null,

  vientosSimulacion: null,

  // PLAN OPERACIONES
  planOperaciones: [],

  // ALINEACIONES CAMPBELL
  alineacionesCampbell: [],

  // ACTIVAR 2D
  is2D: true
}

const getters = {
  isSharingMap: (state) => state.isSharingMap,

  host: (state) => state.host,

  usersShareMap: (state) => state.usersShareMap,

  requestShareMap: (state) => state.requestShareMap,

  mapExtent: (state) => state.mapExtent,

  // DIBUJOS
  graphics: (state) => state.graphics,

  // LAYERS
  visibility: (state) => state.visibility,

  opacity: (state) => state.opacity,

  // SIMULATION
  simulation: (state) => state.simulation,

  simulationTime: (state) => state.simulationTime,

  vientosSimulacion: (state) => state.vientosSimulacion,

  // PLAN OPERACIONES
  planOperaciones: (state) => state.planOperaciones,

  // ALINEACIONES CAMPBELL
  alineacionesCampbell: (state) => state.alineacionesCampbell,

  // ACTIVAR 2D
  is2D: (state) => state.is2D
}

const mutations = {
  SET_IS_SHARING_MAP (state, isSharingMap) {
    state.isSharingMap = isSharingMap
  },

  SET_USERS_SHARE_MAP (state, usersShareMap) {
    state.host = usersShareMap.length > 0
    state.usersShareMap = usersShareMap
  },

  SET_REQUEST_SHARE_MAP (state, requestShareMap) {
    state.requestShareMap = requestShareMap
  },

  CANCEL_REQUEST_SHARE_MAP (state) {
    state.requestShareMap = null
    state.isSharingMap = false
    state.graphics = null
    state.planOperaciones = []
    state.host = false
    ArcGIS.clearSimulacion()
    ArcGIS.stopAlineacionesCampbellSketchViewModel()
  },

  ACCEPT_REQUEST_SHARE_MAP (state) {
    let requestShareMap = state.requestShareMap
    requestShareMap.response = true

    state.isSharingMap = true
  },

  // Recibir peticion de compartir mapa
  SOCKET_requestExtenTMap (state, data) { // La T no es una errata, es asi...
    state.requestShareMap = data
  },

  // Recibir nuevo extent del mapa
  SOCKET_changeExtentMap (state, data) {
    if (state.isSharingMap) {
      state.mapExtent = data
    }
  },

  // Alguien acepta el compartir pantalla
  SOCKET_acceptRequestExtentMap (state, data) {
    let user
    for (let i = 0; i < state.usersShareMap.length; i++) {
      if (state.usersShareMap[i].ID_SOCKET === data) {
        user = state.usersShareMap[i]
        user.ESTADO = 'Aceptada'
        break
      }
    }

    this.notify('Compartir pantalla', `El usuario ${user.USUARIO} ha aceptado la solicitud`)
  },

  // Alguien se ha salido del compartir mapa
  SOCKET_exitRequestExtentMap (state, data) {
    let user
    for (let i = 0; i < state.usersShareMap.length; i++) {
      if (state.usersShareMap[i].ID_SOCKET === data) {
        user = state.usersShareMap[i]
        user.ESTADO = 'Exit'
        break
      }
    }

    this.notify('Compartir pantalla', `El usuario ${user.USUARIO} ha parado la visualización`)
  },

  // Cerrar compartir mapa
  SOCKET_closeRequestExtentMap (state, data) {
    state.requestShareMap = null
    state.isSharingMap = false
    ArcGIS.clearSimulacion()
    ArcGIS.stopAlineacionesCampbellSketchViewModel()
    state.host = false
    state.planOperaciones = []
    this.notify('Compartir pantalla', 'Se ha terminado la sesión')
  },

  // DIBUJOS
  SOCKET_addGraphicsDraw (state, data) {
    state.graphics.push(data)
  },
  SOCKET_updateGraphicsDraw (state, data) {
    let index = state.graphics.findIndex(x => x.attributes.ID === data[0].attributes.ID)
    if (index !== -1) {
      let graphic = state.graphics[index]

      if (data[0].geometry.type === 'polyline') {
        graphic.coordenadas = data[0].geometry.paths
      } else if (data[0].geometry.type === 'polygon') {
        graphic.coordenadas = data[0].geometry.rings[0]
      } else if (data[0].geometry.type === 'point') {
        graphic.coordenadas = [data[0].geometry.x, data[0].geometry.y]
      }

      Vue.set(state.graphics, index, graphic)
    }
  },
  SOCKET_deleteGraphicsDraw (state, data) {
    let index = state.graphics.findIndex(x => x.attributes.ID === data[0].attributes.ID)
    if (index !== -1) {
      state.graphics.splice(index, 1)
    }
  },

  SOCKET_removeGraphicsDraw (state) {
    state.graphics = []
  },

  // LAYERS
  SOCKET_updateLayerVisibilityShare (state, data) {
    if (state.isSharingMap) {
      state.visibility = data
    }
  },

  SOCKET_updateLayerOpacityShare (state, data) {
    if (state.isSharingMap) {
      state.opacity = data
    }
  },

  // SIMULACION
  SOCKET_paintSimulationShare (state, data) {
    if (state.isSharingMap) {
      state.simulation = data
    }
  },

  SOCKET_updateSimulationTimeShare (state, data) {
    if (state.isSharingMap) {
      state.simulationTime = data
    }
  },

  SOCKET_clearSimulationShare (state) {
    if (state.isSharingMap) {
      ArcGIS.clearSimulacion()
    }
  },

  SOCKET_paintVientoShare (state, data) {
    if (state.isSharingMap) {
      state.vientosSimulacion = data
    }
  },

  SOCKET_paintPlanOperacionesShare (state, data) {
    if (state.isSharingMap) {
      state.planOperaciones = data
    }
  },

  // ALINEACIONES CAMPBELL
  SOCKET_paintAlineacionesCampbellShare (state, data) {
    if (state.isSharingMap) {
      state.alineacionesCampbell = data
    }
  },

  SOCKET_stopAlineacionesCampbellShare (state) {
    if (state.isSharingMap) {
      ArcGIS.stopAlineacionesCampbellSketchViewModel()
    }
  },

  // ACTIVAR 2D
  SOCKET_activar2DShare (state, data) {
    if (state.isSharingMap) {
      state.is2D = data
    }
  }
}

const actions = {
  setShareMap ({ commit }, data) {
    if (!data) {
      if (state.requestShareMap) {
        Vue.prototype.$socket.emit('exitRequestExtentMap', {
          ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
          USUARIO: state.requestShareMap.clientRequest.USUARIO
        })
        commit('CANCEL_REQUEST_SHARE_MAP')
      } else {
        Vue.prototype.$socket.emit('closeRequestExtentMap')
        commit('SET_USERS_SHARE_MAP', [])
      }
    }

    commit('SET_IS_SHARING_MAP', data)
  },

  setUsersShareMap ({ commit, state }, data) {
    commit('SET_USERS_SHARE_MAP', data)
    Vue.prototype.$socket.emit('requestUsersExtentMap', data)
  },

  cancelShareMapRequest ({ commit }) {
    Vue.prototype.$socket.emit('exitRequestExtentMap', {
      ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
      USUARIO: state.requestShareMap.clientRequest.USUARIO
    })
    commit('CANCEL_REQUEST_SHARE_MAP')
  },

  acceptShareMapRequest ({ commit }) {
    Vue.prototype.$socket.emit('acceptRequestExtentMap', {
      ID_SOCKET: state.requestShareMap.clientRequest.ID_SOCKET,
      USUARIO: state.requestShareMap.clientRequest.USUARIO
    })
    commit('ACCEPT_REQUEST_SHARE_MAP')
  },

  changeMapExtent ({ commit }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('changeExtentMap', data)
    }
  },

  // DIBUJOS
  addGraphics ({ commit }, data) {
    commit('SOCKET_addGraphicsDraw', data)
    Vue.prototype.$socket.emit('addGraphicsDraw', data)
  },
  deleteGraphics ({ commit, state }, data) {
    commit('SOCKET_deleteGraphicsDraw', data)
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('deleteGraphicsDraw', data)
    }
  },
  updateGraphics ({ commit, state }, data) {
    commit('SOCKET_updateGraphicsDraw', data)
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('updateGraphicsDraw', data)
    }
  },
  removeAllGraphics ({ commit }) {
    commit('SOCKET_removeGraphicsDraw')
    Vue.prototype.$socket.emit('removeGraphicsDraw')
  },

  // LAYERS
  updateLayerVisibility ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('updateLayerVisibilityShare', data)
    }
  },

  updateLayerOpacity ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('updateLayerOpacityShare', data)
    }
  },

  // SIMULACION
  paintSimulation ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('paintSimulationShare', data)
    }
  },

  updateSimulationTime ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('updateSimulationTimeShare', data)
    }
  },

  clearSimulation ({ state }) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('clearSimulationShare')
    }
  },

  paintViento ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('paintVientoShare', data)
    }
  },

  // PLAN OPERACIONES
  paintPlanOperaciones ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('paintPlanOperacionesShare', data)
    }
  },

  // ALINEACIONES CAMPBELL
  paintAlineacionesCampbell ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('paintAlineacionesCampbellShare', data)
    }
  },

  stopAlineacionesCampbell ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('stopAlineacionesCampbellShare', data)
    }
  },

  // ACTIVAR 2D
  activar2D ({ state }, data) {
    if (state.isSharingMap && state.host) {
      Vue.prototype.$socket.emit('activar2DShare', data)
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
